import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, User, UserService } from '@rentigo/ngx-authorization';
import { filter, map, Observable } from 'rxjs';
import { ThemeService } from './theme.service';
import { ManagerSettingsService } from '../../security-deposit/common/services/manager-settings.service';

@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  @ViewChild('drawer') drawer!: MatSidenav;

  readonly theme = inject(ThemeService);
  private readonly bp = inject(BreakpointObserver);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly managerSettingsService = inject(ManagerSettingsService);

  user?: User;
  hasUnreadNotifications = true;

  readonly isHandset$: Observable<boolean> = this.bp
    .observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
    .pipe(map(r => r.matches));

  ngOnInit(): void {
    try { this.user = this.userService.getUser(); } catch { /* not authenticated */ }

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.drawer && this.drawer.mode === 'over') {
          this.drawer.close();
        }
      });
  }

  get userInitials(): string {
    const name = this.user?.name?.trim() ?? '';
    if (!name) return '?';
    const parts = name.split(/\s+/).slice(0, 2);
    return parts.map(p => p[0]?.toUpperCase() ?? '').join('') || '?';
  }

  get isAuthenticated(): boolean {
    return this.user?.isAuthenticated ?? false;
  }

  toggleTheme(): void {
    this.theme.toggle();
  }

  logout(): void {
    this.managerSettingsService.clear();
    this.authService.removeToken();
    this.authService.redirectToLogin();
  }
}
